<template>
<bim-row id="action-time" class="services-lending__action-container" justify="center">
  <bim-col cols="12" sm="7">
    <p class="action__title">Время действовать!</p>
    <h2 class="action__info">Получите бесплатную консультацию у наших специалистов.<br />Не ждите, пока конкуренты обойдут вас.</h2>
    <bim-button @click="$emit('showModal')" v-metric="'LENDING-BIM_CLICK-ON-SEND-REQUEST-TO-BUY-TARIFF'" class="get-access__button" size="l" label="Получить доступ"></bim-button>
    <!-- <p class="access__questions">есть вопросы?</p>
    <p class="access__consult">Проконсультируем бесплатно</p>
    <a class="access__phone" href="tel:88005002575">8 800 500-25-75</a> -->
  </bim-col>
</bim-row>
</template>

<script>
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'
import bimButton from '@bimlib/components/bimButton'

export default {
  components: {
    bimRow,
    bimCol,
    bimButton
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";

.services-lending__action-container {
  z-index: 1;
  position: relative;
  padding: 140px 0;
  text-align: center;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100vw;
    height: 100%;
    background-color: $primary-color-75;
    z-index: -1;
  }

  .action__title {
    font-size: 50px;
    font-weight: bold;
    padding-bottom: 25px;
  }

  .action__info {
    font-size: 24px;
    line-height: 1.42;
    padding-bottom: 30px;
  }

  @media screen and (max-width: 575px) {
    padding: 42px 0;

    .action__title {
      font-size: 18px;
      padding-bottom: 25px;
    }
  
    .action__info {
      font-size: 14px;
      line-height: 1.57;
      padding-bottom: 30px;
      letter-spacing: 0.2px;
    }
  }
}
.access__questions { // есть вопросы? 
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin: 30px 25px;
}

.access__consult { // проконсультируем бесплатно
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0.2px;
  margin-bottom: 15px;
}

.access__phone { // номер телефона
  font-size: 24px;
  font-weight: bold;

  &:hover {
    color: $primary-color;
  }
}
</style>
